import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { map, tap } from "rxjs/operators";

@Injectable()
export class PublicMarcaService {
  private modelCache = {};
  private marcaCache = {};

  constructor(private publicHttp: PublicHttpClientService) {}

  public getMarcasModelos(): Observable<any> {
    return this.publicHttp
      .get("/api/public/marcas/marcas_modelos")
      .pipe(tap((_) => console.log("MarcasService.getMarcasModelos: Ok.")));
  }

  public getAll(
    application_id?: number,
    person_id?: number,
    forceRefresh: boolean = false,
    external_quote_id?: number
  ): Observable<any[]> {
    const key = `all_${application_id || "none"}_${person_id || "none"}`;
    if (forceRefresh || !this.marcaCache[key]) {
      this.marcaCache[key] = this.requestAll(application_id, person_id, external_quote_id).pipe(shareReplay(1));
    }
    return this.marcaCache[key];
  }

  private requestAll(application_id?: number, person_id?: number, external_quote_id?: number): Observable<any[]> {
    const params: { [key: string]: string } = {};
    if (application_id) params.application_id = application_id.toString();
    if (person_id) params.person_id = person_id.toString();
    if (external_quote_id) params.external_quote_id = external_quote_id.toString();
    return this.publicHttp
      .get("/api/public/marcas", { params })
      .pipe(tap((_) => console.log("MarcasService.getAll: Ok.")));
  }

  public getModels(id): Observable<any[]> {
    if (!this.modelCache[id]) {
      this.modelCache[id] = this.requestModels(id).pipe(shareReplay(1));
    }
    return this.modelCache[id];
  }

  public requestModels(id, year?): Observable<any[]> {
    let options = { params: { year } };
    return this.publicHttp
      .get("/api/public/marcas/" + id + "/modelos", options)
      .pipe(tap((_) => console.log("MarcasService.getModels: Ok.")));
  }

  public getVersions(id: number, year?): Observable<any> {
    let options = { params: { year, by_year: year ? true : false } };
    return this.publicHttp
      .get("/api/public/modelos/" + id + "/versiones", options)
      .pipe(tap((_) => console.log("MarcasService.getVersiones: Ok.")));
  }
}
